import { Component, inject } from '@angular/core';
import {VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {INotificationModalData} from '../../models';

@Component({
    selector: 'app-notification-modal',
    templateUrl: './notification-modal.component.html',
    styleUrls: ['./notification-modal.component.scss'],
    standalone: false
})
export class NotificationModalComponent {
    modalRef = inject(VwuiModalRef);
    modalConfig = inject<VwuiModalConfig<INotificationModalData>>(VwuiModalConfig);

}
